import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import * as Ladda from "ladda";
import Swal from "sweetalert2";
import GoogleMap from "../components/GoogleMap";
import updatePaymentUI from "../components/payments/subscription-card-update";
$(function () {
    if ($("#holiday-date-range-form").length) {
        initHolidayDateRange();
    }
    if ($("#subscription-payment-form").length) {
        updatePaymentUI();
        initCollectionUI();
        initCancelForm();
    }
    if ($(".btn-subscription-line-update").length) {
        initSubscriptionEdit();
    }
    if ($(".subscription-map").length) {
        initSubscriptionMap();
    }
    // ─── Generic Account Stuff ──────────────────────────────────────────────────────
    $(".show-plan-details").on("click", function () {
        var id = $(this).data("id");
        var $el = $(`#line_details_${id}`);
        $el.slideToggle();
    });
});
function initHolidayDateRange() {
    flatpickr("#start_date", {
        mode: "range",
        dateFormat: "m/d/Y",
        //@ts-ignore
        plugins: [new rangePlugin({ input: "#end_date" })],
    });
}
function initCollectionUI() {
    $("#collection").change(toggleCollection);
    toggleCollection();
}
function initSubscriptionEdit() {
    //@ts-ignore
    const subscriptionLineModal = new bootstrap.Modal("#subscriptionLineModal", {
        keyboard: false
    });
    $(".btn-subscription-line-update").each(function () {
        $(this).on("click", function () {
            const uuid = $(this).data("uuid");
            const lineId = $(this).data("line");
            $("#subscriptionLineModal .modal-body").load(`/ajax/subscriptionLineEdit?uuid=${uuid}&line=${lineId}`, function () {
                if (typeof Ladda !== "undefined")
                    Ladda.stopAll();
                subscriptionLineModal.show();
                //initQtyInputGroups()        //Init qty input groups
                //Finally, enable ladda script on submit btn
                Ladda.bind("#line-submit-btn");
            });
        });
    });
}
function initSubscriptionMap() {
    GoogleMap.loadGoogleMapsApi().then((googleMaps) => {
        $(".subscription-map").each(function () {
            const latLng = $(this).data("latlng");
            const dType = $(this).data("type");
            const address = $(this).data("address");
            if (latLng !== "") {
                try {
                    const latLngObj = latLng.split(",");
                    GoogleMap.createMap(googleMaps, $(this)[0], parseFloat(latLngObj[0]), parseFloat(latLngObj[1]), dType, address);
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                console.log("Map skipped");
            }
        });
    });
}
function toggleCollection() {
    var $shippingEl = $("#shipping_address");
    var $collectionEl = $("#collection");
    var $collectHolder = $("#collection_msg");
    var $locationChecks = $("input[name='location']");
    const isChecked = $collectionEl.is(":checked");
    if (isChecked) {
        //User wants to collection delivery
        $shippingEl.slideUp();
        $collectHolder.slideDown();
        $shippingEl.rules("remove", "required");
        $locationChecks.each(function () {
            //@ts-ignore JQuery stuff
            $(this).rules("add", { required: true });
        });
    }
    else {
        //Users wants parcel delivered
        $shippingEl.slideDown();
        $collectHolder.slideUp();
        $shippingEl.rules("add", { required: true });
        $locationChecks.each(function () {
            //@ts-ignore JQuery stuff
            $(this).rules("remove", "required");
        });
    }
}
function initCancelForm() {
    $("#subscription-cancel-form").submit(function (e) {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            text: "This will cancel you current subscription",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Dismiss",
            confirmButtonText: "Cancel my subscription",
            confirmButtonColor: "#B2303E"
        }).then(result => {
            if (result.isConfirmed) {
                //@ts-ignore: jquery tings
                e.currentTarget.submit();
            }
        });
    });
}
